<template >
  <div name="outcomes" class="inner">
         <div name="innertopbar" class="flex top-bar justify-between pl-2">
        <button class="filter-bar-button" @click="closeWindow()">
          <i class="fas fa-chevron-left " title="Close"></i> Back to {{ course.name }}
      </button>

      <div>
  <div
          v-if="hasMultipleSelection && pupilsSelected.length > 0"
          class="flex pt-2"
        >
          <button
            @click="selectAll()"
            type="button"
            class="filter-bar-button hover:opacity-75 focus:outline-none bg-white"
          >
            <i class="fas fa-check-circle"></i>
            {{ selectAllPupilsTitle }}
          </button>

          <button
            @click="showingOutcomeView = true"
            type="button"
            class="filter-bar-button hover:opacity-50 bg-opacity-75 focus:outline-none bg-action-blue text-white"
          >
            <i class="fas fa-tasks"></i>
            Set outcomes for {{ pupilsSelected.length }}
          </button>
        </div>
        <div class="flex pt-2">
          <div>
            <input
              type="search"
              class="filter-bar-search focus:outline-none w-56"
              name="search"
              v-model="search"
              placeholder="Search pupils..."
            />
            <i
              class="fas fa-times text-sm absolute -ml-8 mt-4 cursor-pointer hover:opacity-50"
              @click="clearTags()"
              title="Clear search"
              v-show="search.length > 0"
            ></i>
          </div>


            <button
              @click="toggleSelect()"
              type="button"
              class="filter-bar-button hover:opacity-75 focus:outline-none"
              v-bind:class="hasMultipleSelection ? 'bg-gray-400' : 'bg-white'"
            >
              <i class="fas fa-object-group"></i>
              Multi Select
            </button>
       

              <button class="filter-bar-button" @click="closeWindow()">
          <i class="fas fa-times " title="Close"></i> Close
      </button>
        </div>

      </div>
  
    </div>
    <div class="ml-6 mb-6">
      <header class="flex justify-between mt-4 mb-6">
           <div class="flex mb-2">
                    <div class="mr-2 w-16 h-16 p-1 bg-purple-200 bg-opacity-25  rounded-full text-center "> 
                      <i class="fas fa-bullseye text-3xl text-base text-purple-800 opacity-75  pt-4" title="Overview"></i></div>
                    
                    <div class="pt-2"> 
                       <h3 class="text-xl font-semibold">Unit Outcomes</h3>
                      <p class="text-xs pl-1 font-medium ">Please select a pupil to view or set outcomes.</p>
                    </div>
                      
                    </div>

      </header>

      <transition name="fade">
        <div class="loading" v-show="loading">
          <span class="fa fa-spinner fa-spin"></span> Loading
        </div>
      </transition>

      <div v-if="errored" class="empty">
        <p>
          We are not able to retrieve this information at the moment, please try
          back later
        </p>
      </div>

      <pupilsselect
        v-if="componentLoaded"
        :allowMultiple="hasMultipleSelection"
        @pupil-selected="selectPupil"
        :selectedPupils="pupilsSelected"
        :orderedPupils="pupils"
        :inputSearch="search"
      >
      </pupilsselect>

      <ModalSlide
        :show="showingOutcomeView"
        :cssWidth="'md:w-6/12'"
        @closeModal="closeOutcomeView()"
      >
        <template v-slot:header-icon>
          <i class="fas fa-calendar-alt"></i>
        </template>
        <template v-slot:header-title> {{ title }} </template>
        <template v-slot:body>
          <OutcomeGradeSelection v-if="displayOutcomes"
          :course="course"
          :pupil="selectedPupil"
          @outcomeGradeSet="setOutcomeGrade"
          @outcomeGradeDelete="deleteOutcomeGrade"
          ></OutcomeGradeSelection>

          <div v-else class="pl-4">No outcomes available for selected Unit</div>
        </template>
      </ModalSlide>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { OutcomeService } from "@/services/outcome.service";
import { calendarYearList } from "@/assets/js/utils";

const ModalSlide = () => import("@/components/ModalSlide.vue");
const pupilsselect = () => import("@/components/PupilsGridSelect.vue");
const OutcomeGradeSelection = () => import("@/components/curriculum/OutcomeGradeSelection.vue");

export default {
  name: "outcomes",
  props: {
    course: Object,
    pupils: Array,
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",
    }),
    displayOutcomes() {
      return (
        this.showingOutcomeView &&
        (this.pupilsSelected.length > 0 || this.hasSelectedPupil)
      );
    },
    componentLoaded() {
      return this.loading == false;
    },
    title() {
      return this.hasSelectedPupil
        ? "Outcomes for " + this.selectedPupil.name
        : "Setting Outcomes for " + this.pupilsSelected.length + " pupils";
    },
    selectAllPupilsTitle() {
      return this.hasSelectAllPupils ? "Deselect All" : "Select All";
    },
    gradesList() {
      return this.settings.assessmentGradesList.filter((c) => c.used === true);
    },
    hasSelectedPupil() {
      return this.selectedPupil != undefined || this.selectedPupil != null;
    },
  },
  data: function () {
    return {
      errored: false,
      loading: true,
      outcomeMarks: [],
      pupilsSelected: [],
      selectedPupil: undefined,
      hasMultipleSelection: false,
      showingOutcomeView: false,
      search: "",
      hasSelectAllPupils: false,
      hasSelectAllOutcomes: false,
    };
  },
  created() {},
  mounted() {
    this.fetchOutcomeGrades();
  },
  methods: {
    isSchoolType(outcome) {
      return outcome.type_id === 3
    },
    setMultiStyle(object, grade) {
      if (this.hasMultiGrade(object, grade) != undefined) {
        let icon = grade.key == "greater" ? "fa-star" : "fa-check-circle";
        return "bg-" + grade.color + " text-white" + " fas " + icon;
      } else {
        return (
          "text-gray-500 bg-gray-200 far fa-dot-circle " +
          "hover:" +
          grade.background
        );
      }
    },
    isSelectedPupilStyle(pupil) {
      return (
        this.hasSelectedPupil &&
        this.selectedPupil.identifier === pupil.identifier
      );
    },
    fetchOutcomeGrades() {

      // fetch grades
      OutcomeService.getCourseGrades(this.course.id)
        .then((response) => (this.outcomeMarks = response.data.data))
        .catch((err) => {
          console.log("Grades " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    outcomesOrderedBySection(section) {
      return this.outcomesOrdered.filter((o) => o.criteria === section);
    },
    getSectionTitle(section) {
      return section;
    },
    gradeCount(pupil) {
      return this.outcomeMarks.filter(
        (o) => o.register_identifier === pupil.identifier
      ).length;
    },
    setOutcomeGrade(object, grade) {
      let vm = this;
      if (this.hasMultipleSelection) {
        vm.pupilsSelected.forEach(function (pp, index) {
          vm.processCreateGrade(pp, grade, object);
       });
      } else {
        this.processCreateGrade(this.selectedPupil, grade, object);
      }
    },
    deleteOutcomeGrade(object) {
      let vm = this;
        OutcomeService.deleteGrade(object)
          .then((response) => {
            vm.outcomeMarks = vm.outcomeMarks.filter(
              (o) => o.identifier !== object.identifier
            );
          })
          .catch((err) => {
            console.log("GRADE DELETE error " + err);
          });
    },
    processCreateGrade(pupil, grade, object) {
      let vm = this;
      let calendarYear = calendarYearList().find((y) => y.current === true);

      let payload = {
        course_id: vm.course.id,
        register_identifier: pupil.identifier,
        calendar_schoolyear: calendarYear.value,
        grade: grade.score,
        outcome_identifier: object.identifier,
      };

      OutcomeService.addGrade(payload)
        .then((response) => {
          payload.identifier = response.data.identifier;

          vm.outcomeMarks.push(payload);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectPupil(pupil) {
      if (this.hasMultipleSelection) {
        if (
          this.pupilsSelected.some((p) => p.identifier === pupil.identifier)
        ) {
          this.pupilsSelected.splice(
            this.pupilsSelected.findIndex(
              (item) => item.identifier === pupil.identifier
            ),
            1
          );
        } else {
          this.pupilsSelected.push(pupil);
        }
      } else {
        this.selectedPupil = pupil;
        this.showingOutcomeView = true;
      }
    },
    toggleSelect() {
      this.hasMultipleSelection = !this.hasMultipleSelection;
      if (this.hasMultipleSelection === false) {
        this.clearSelections();
      }
    },
    selectAll() {
      let vm = this;
      vm.hasSelectAllPupils = !vm.hasSelectAllPupils;
      if (vm.hasSelectAllPupils) {
        vm.pupils.forEach(function (pp, index) {
          if (
            vm.pupilsSelected.some((p) => p.identifier === pp.identifier) ===
            false
          ) {
            vm.pupilsSelected.push(pp);
          }
        });
      } else {
        vm.clearSelections();
      }
    },
    clearSelections() {
      this.selectedPupil = undefined;
      this.pupilsSelected = [];
    },
    closeOutcomeView() {
      this.showingOutcomeView = false;
      this.hasMultipleSelection = false
      this.clearSelections();
    },
        closeWindow() {
      this.$router.push({ name: "UnitView" });
    },
  },
  components: {
    pupilsselect,
    ModalSlide,
    OutcomeGradeSelection
  },
};
</script>

<style scoped>
</style>